export const data = [
  {
    title: "ISO 9001 – 2015 – Quality",
    link: "https://cdn.fashionbiz.com/bizz-react/corporate-social-responsibility/ISO 9001 2015 - Quality Management Systems.pdf",
  },
  {
    title: "ISO 14001 – 2015 – Environmental",
    link: "https://cdn.fashionbiz.com/bizz-react/corporate-social-responsibility/ISO 14001 2015 - Environmental Management Systems.pdf",
  },
  {
    title: "ISO 45001 -2018 - Safety",
    link: "https://cdn.fashionbiz.com/bizz-react/corporate-social-responsibility/ISO 45001 2018 - Occupational Health and Safety Management Systems.pdf",
  },
];
